import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Icon } from "antd";
import withTracker from "./../../withTracker";

class Paths extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: {
        paths: undefined,
      },
    };
  }

  componentDidMount() {
    if (this.props && !this.props.data.data.loading) {
      this.setState({ loading: false, data: this.props.data.data });
    }
  }

  onFilterPaths(e) {
    let newArr = this.props.data.data.paths.filter((z) => {
      return z.Name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1;
    });
    this.setState({ data: { ...this.state.data, paths: newArr } });
  }

  render() {
    return (
      <div>
        <span className="title">ŚCIEŻKI</span>
        <div className="paths">
          <main className="list">
            <input
              placeholder="Wpisz nazwę ścieżki..."
              onChange={(e) => this.onFilterPaths(e)}
            ></input>
            <Icon type="search" />
            <ul className="ul-paths">
              {!this.state.loading &&
                this.state.data.paths
                  .filter(
                    (path) => path.Cemetery === this.props.match.params.cemetery
                  )
                  .map((path) => (
                    <li key={path.ID}>
                      <Link to={`/${this.props.data.name}/path/${path.ID}`}>
                        {path.Name}
                      </Link>
                    </li>
                  ))}
            </ul>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(Paths)));



// WEBPACK FOOTER //
// ./src/js/containers/paths/index.js